/* eslint-disable react/react-in-jsx-scope */
import PropTypes from 'prop-types';
import { ReactComponent as FileIcon } from 'src/assets/icons/extension/file.svg';

import { ReactComponent as CsvIcon } from 'src/assets/icons/extension/csv.svg';
import { ReactComponent as DocxIcon } from 'src/assets/icons/extension/docx.svg';
import { ReactComponent as ExeIcon } from 'src/assets/icons/extension/exe.svg';
import { ReactComponent as HtmlIcon } from 'src/assets/icons/extension/html.svg';
import { ReactComponent as ImgIcon } from 'src/assets/icons/extension/img.svg';
import { ReactComponent as OutlookIcon } from 'src/assets/icons/extension/outlook.svg';
import { ReactComponent as PdfIcon } from 'src/assets/icons/extension/pdf.svg';
import { ReactComponent as PowerpointIcon } from 'src/assets/icons/extension/pptx.svg';
import { ReactComponent as RtfIcon } from 'src/assets/icons/extension/rtf.svg';
import { ReactComponent as TxtIcon } from 'src/assets/icons/extension/txt.svg';
import { ReactComponent as ZipIcon } from 'src/assets/icons/extension/zip.svg';

export default function ExtensionIcon({ extension }) {
  const lowerExt = extension.toLowerCase();

  if (lowerExt.includes('.csv')) return <CsvIcon />;
  if (lowerExt.includes('.docx')) return <DocxIcon />;
  if (lowerExt.includes('.exe')) return <ExeIcon />;
  if (lowerExt.includes('.file')) return <FileIcon />;
  if (lowerExt.includes('.html')) return <HtmlIcon />;
  if (lowerExt.includes('.outlook')) return <OutlookIcon />;
  if (lowerExt.includes('.pdf')) return <PdfIcon />;
  if (lowerExt.includes('.pptx')) return <PowerpointIcon />;
  if (lowerExt.includes('.rtf')) return <RtfIcon />;
  if (lowerExt.includes('.txt')) return <TxtIcon />;
  if (lowerExt.includes('.zip')) return <ZipIcon />;
  if (
    lowerExt.includes('.png') ||
    lowerExt.includes('.jpg') ||
    lowerExt.includes('.jpeg') ||
    lowerExt.includes('.gif') ||
    lowerExt.includes('.bmp') ||
    lowerExt.includes('.webp') ||
    lowerExt.includes('.svg') ||
    lowerExt.includes('.tiff') ||
    lowerExt.includes('.ico')
  )
    return <ImgIcon />;

  return <FileIcon />;
}

ExtensionIcon.propTypes = {
  extension: PropTypes.string.isRequired,
};
